import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

// Función para formatear moneda
function formatCurrency(value) {
  if (value === null || value === undefined) return 'RD$0.00';
  let numValue;
  if (typeof value === 'string') {
    numValue = parseFloat(value.replace(/,/g, ''));
  } else if (typeof value === 'number') {
    numValue = value;
  } else {
    return 'RD$0.00';
  }
  return numValue.toLocaleString('es-DO', {
    style: 'currency',
    currency: 'DOP',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

// Parse number seguro (para calcular precio unitario si falta)
function parseNumber(v){
  if(v===null||v===undefined||v==='') return 0;
  if(typeof v === 'number') return v;
  const n = Number(String(v).replace(/,/g,''));
  return isNaN(n)?0:n;
}

// Función para formatear fecha
function formatDate(dateString) {
  if (!dateString) return 'No registrada';
  const date = new Date(dateString);
  return date.toLocaleDateString('es-DO', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
}

// Función para agregar pie de página con numeración
function addFooter(doc, currentPage, totalPages) {
  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;
  const margin = 15;
  const footerY = pageHeight - 25;
  
  doc.setDrawColor(139, 69, 19);
  doc.setLineWidth(0.5);
  doc.line(margin, footerY, pageWidth - margin, footerY);
  
  doc.setFontSize(7);
  doc.setFont('helvetica', 'italic');
  doc.setTextColor(100, 100, 100);
  doc.text('Este documento ha sido generado electrónicamente y no es válido (Versión de Práctica).', margin, footerY + 5);

  doc.text(`Generado el: ${new Date().toLocaleString('es-DO')} (Práctica)`, margin, footerY + 10);
  
  // Texto centrado del pie
  const footerText = "D'Princess Foto Films (Práctica) - Capturando momentos únicos";
  const footerWidth = doc.getTextWidth(footerText);
  doc.text(footerText, (pageWidth - footerWidth) / 2, footerY + 15);
  
  // Número de página en el borde inferior derecho
  doc.setFontSize(8);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(80, 80, 80);
  const pageText = `Página ${currentPage} / ${totalPages} (Práctica)`;
  const pageTextWidth = doc.getTextWidth(pageText);
  doc.text(pageText, pageWidth - margin - pageTextWidth, footerY + 15);
}

// Función principal para generar PDF de nota de débito
export const generateDebitNotePDF = (debitNoteData, invoiceData, debitNoteDetails) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;
  const margin = 15;
  let yPosition = 15;
  let currentPage = 1;

  // Configurar fuentes
  doc.setFont('helvetica');

  // NOTA DE PRÁCTICA AL INICIO
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(255, 0, 0); // Rojo para destacar
  doc.text('*** VERSIÓN DE PRÁCTICA - INFORMACIÓN FICTICIA ***', margin, yPosition);
  yPosition += 6;
  doc.setFontSize(8);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(0, 0, 0);
  doc.text('Esta información es ficticia y se utiliza únicamente con fines prácticos. No representa datos reales.', margin, yPosition);
  yPosition += 6;

  // ENCABEZADO PRINCIPAL
  doc.setFontSize(18);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(139, 69, 19);
  doc.text("D'Princess Foto Films (Práctica)", margin, yPosition);
  
  yPosition += 6;
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(0, 0, 0);
  doc.text('Servicios Profesionales de Fotografía y Video (Versión de Práctica)', margin, yPosition);
  
  yPosition += 4;
  doc.setFontSize(8);
  doc.text('Tel.: (809) 708-5336 • Email: info@dprincess.com (Práctica)', margin, yPosition);
  
  // TÍTULO DEL DOCUMENTO
  yPosition += 12;
  doc.setFontSize(16);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(0, 100, 0); // Verde para diferenciar de crédito (rojo)
  const titleText = 'NOTA DE DÉBITO (PRÁCTICA)';
  const titleWidth = doc.getTextWidth(titleText);
  doc.text(titleText, (pageWidth - titleWidth) / 2, yPosition);
  
  // Número de nota de débito
  yPosition += 6;
  doc.setFontSize(12);
  doc.setTextColor(0, 0, 0);
  const numberText = `No. ${debitNoteData.debitNoteNumber}`;
  const numberWidth = doc.getTextWidth(numberText);
  doc.text(numberText, (pageWidth - numberWidth) / 2, yPosition);
  
  // Línea decorativa
  yPosition += 4;
  doc.setDrawColor(0, 100, 0); // Verde para diferenciar
  doc.setLineWidth(0.5);
  doc.line(margin, yPosition, pageWidth - margin, yPosition);
  
  // INFORMACIÓN DE LA EMPRESA Y CLIENTE
  yPosition += 10;
  doc.setFontSize(9);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(0, 0, 0);
  
  const leftColumnData = [
    'DATOS DE LA EMPRESA (PRÁCTICA):',
    'D\'Princess Foto Films (Práctica)',
  ];
  
  const rightColumnData = [
    'DATOS DEL CLIENTE (PRÁCTICA):',
    `Cliente: ${invoiceData.clientName || 'No registrado'} (Práctica)`,
  ];
  
  const rightColumnX = pageWidth / 2 + 5;
  
  for (let i = 0; i < Math.max(leftColumnData.length, rightColumnData.length); i++) {
    doc.setFont('helvetica', i === 0 ? 'bold' : 'normal');
    if (leftColumnData[i]) {
      doc.text(leftColumnData[i], margin, yPosition);
    }
    if (rightColumnData[i]) {
      doc.text(rightColumnData[i], rightColumnX, yPosition);
    }
    yPosition += 5;
  }
  
  // INFORMACIÓN GENERAL DE LA NOTA DE DÉBITO
  yPosition += 5;
  doc.setDrawColor(180, 180, 180);
  doc.setLineWidth(0.2);
  doc.line(margin, yPosition, pageWidth - margin, yPosition);
  yPosition += 8;
  
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.text('INFORMACIÓN DE LA NOTA DE DÉBITO (PRÁCTICA)', margin, yPosition);
  yPosition += 6;
  
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.text(`Factura Relacionada: ${invoiceData.invoiceNumber}`, pageWidth / 2, yPosition);
  yPosition += 5;
  doc.text(`Estado: ${debitNoteData.paymentStatus === 'pendiente' ? 'Pendiente de Pago' : 'Pagado'}`, margin, yPosition);
  yPosition += 8;

  // MOTIVO
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.text('MOTIVO DE LA NOTA DE DÉBITO (PRÁCTICA):', margin, yPosition);
  yPosition += 5;
  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  const reasonLines = doc.splitTextToSize(debitNoteData.reason || 'No especificado', pageWidth - margin * 2);
  doc.text(reasonLines, margin, yPosition);
  yPosition += reasonLines.length * 5 + 5;

  // TABLA DE DETALLES (Servicios + cargos)
  const tableColumn = ["# (Práctica)", "Servicio (Práctica)", "Cant (Práctica)", "P.Unit (Práctica)", "Concepto (Práctica)", "Monto Debitado (Práctica)"];
  const tableRows = [];

  debitNoteDetails.forEach((detail, index) => {
    const serviceName = detail.serviceName;
    // Posibles campos de cantidad
    const qty = detail.quantity || detail.qty || detail.serviceQty || 1;
    const amountNum = parseNumber(detail.amount);
    let unitPrice = detail.unitPrice || detail.price || detail.servicePrice;
    const concept = detail.concept || 'No especificado';
    if(unitPrice === undefined || unitPrice === null){
      unitPrice = qty ? (amountNum/qty) : amountNum;
    }
    const row = [
      index + 1,
      serviceName,
      String(qty),
      formatCurrency(unitPrice),
      concept,
      formatCurrency(amountNum)
    ];
    tableRows.push(row);
  });

  autoTable(doc, {
    head: [tableColumn],
    body: tableRows,
    startY: yPosition,
    theme: 'grid',
    headStyles: {
      fillColor: [139, 69, 19],
      textColor: 255,
      fontStyle: 'bold'
    },
    styles: { fontSize: 8 },
    columnStyles: {
      0: { halign: 'center', cellWidth: 8 },
      1: { cellWidth: 70 },
      2: { halign: 'center', cellWidth: 12 },
      3: { halign: 'right', cellWidth: 20 },
      4: { halign: 'right', cellWidth: 25 }
    },
    didDrawPage: () => {
      addFooter(doc, currentPage, doc.internal.getNumberOfPages());
      currentPage++;
    }
  });

  // Posicionar debajo de la tabla (compatibilidad con distintas versiones de jspdf-autotable)
  const finalY = (doc.lastAutoTable?.finalY) || (doc.autoTable?.previous?.finalY) || yPosition;
  yPosition = finalY + 10;

  // TOTALES
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text('Monto Total Debitado (Práctica):', pageWidth - margin - 70, yPosition);
  doc.setTextColor(0, 100, 0); // Verde para diferenciar
  doc.text(formatCurrency(debitNoteData.amount), pageWidth - margin, yPosition, { align: 'right' });
  doc.setTextColor(0, 0, 0);
  yPosition += 10;

  // DISCLAMER ADICIONAL AL FINAL
  doc.setFontSize(8);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(255, 0, 0);
  doc.text('*** IMPORTANTE: Esta es una versión de práctica. Toda la información es ficticia. ***', margin, yPosition);
  yPosition += 5;
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(0, 0, 0);
  doc.text('No utilizar para fines comerciales reales. Rama Practica - Versión de Desarrollo.', margin, yPosition);

  return doc;
};
